export enum SOURCE {
  PDP = 'pdp',
  CART = 'cart',
}

export enum EDD_SOURCE_PAGE {
  PDP = 'pdp_page',
  CART = 'cart_page',
}

export const EDD_AB_EXPERIMENT = 'edd-header-ab';
export const EDD_VARIANT_1 = 'edd-header-V1';

export const EDD_DEFAULT_DELIVERY_TEXT = 'Delivery in 3-5 days';
export const NO_RETURN_EXCHANGE_TEXT = 'No return, No exchange';

export const UNABLE_TO_DELIVER = 'Unable to deliver';

export const EDD_EVENTS = {
  DELVIERY_WIDGET_LOADS: 'delivery_widget_loads',
  PDP_PINCODE_CLICKED: 'pdp_pincode_clicked',
  PDP_CHANGE_DELIVERY_PINCODE: 'pdp_change_delivery_pincode_edd',
  CART_PINCODE_CLICKED: 'cart_pincode_clicked',
  CART_CHANGE_DELIVERY_PINCODE: 'cart_change_delivery_pincode',
};

export enum PINCODE_SELECTION_METHOD {
  MANUAL = 'manual',
  ADDRESS_LIST = 'addressList',
}

export const EDD_PLACEHOLDER_DIMENSIONS = {
  DELIVERY_TITLE: 20,
  DELIVERY_SUBTITLE: 16,
  ACTION_WIDTH: 86,
  ACTION_HEIGHT: 40,
  POLICY_ROW: 32,
};
